export default __webpack_public_path__ + "static/media/main_section17.4fcfbd70.jpg";